import { gql } from '@apollo/client';

import { GeneralRankingStudent, RankingStats } from '../../types';
import { generalRankingStudentFragment } from '../fragments';

export interface GetGeneralRankingQueryVariables {
  courseId: string;
  queryParams: {
    startDate?: string;
    endDate?: string;
  };
}

export interface GetGeneralRankingQueryResult {
  generalRankingPayload: {
    courseId: string;
    courseName: string;
    students: GeneralRankingStudent[];
    stats: RankingStats;
  };
}

export const getGeneralRankingQuery = gql`
  query GetGeneralRankingQuery($courseId: String!, $queryParams: QueryParamsVariables!) {
    generalRankingPayload(courseId: $courseId, queryParams: $queryParams)
      @rest(
        type: "GeneralRankingPayload"
        path: "courses/{args.courseId}/leaderboard/general?startDate={args.queryParams.startDate}&endDate={args.queryParams.endDate}"
      ) {
      courseId
      courseName
      students @type(name: "GeneralRankingStudent") {
        ...GeneralRankingStudent
      }
      stats {
        average
      }
    }
  }
  ${generalRankingStudentFragment}
`;
